module.exports = __webpack_public_path__ + "static/img/rank_228.81dcfea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_228.png
// module id = PYCc
// module chunks = 0